import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function linkButton(theme: Theme): ComponentStyle {
  return {
    componentName: 'linkButton',
    baseStyle: {
      display: 'flex',
      flexGrow: 0,
      alignItems: 'center',
      fontSize: theme.sizes['-1'],
      fontWeight: 600,
      color: theme.colors.spark.gray40,
      backgroundColor: theme.colors.foreground,
      borderRadius: theme.sizes['-4'],
      transition: 'all 0.15s cubic-bezier(0.4, 0, 0.2, 1)',

      ['&:hover']: {
        backgroundColor: theme.colors.spark.gray90
      }
    },
    variants: {
      fancy: {
        fontSize: theme.sizes['0'],
        backgroundImage:
          'linear-gradient(270.98deg,#ffcd4d -5.71%,#fa43bd 102.6%)',
        width: 'fit-content',
        position: 'relative',
        padding: `${theme.space['xs']} ${theme.space['m']}`,
        transition: 'unset',
        color: '#ffffff',

        ['&:hover']: {
          backgroundColor: theme.colors.spark.black,
          backgroundImage: 'unset',
          color: '#ffffff'
        }
      },
      fancySecondary: {
        fontSize: theme.sizes['-1'],
        backgroundImage: 'linear-gradient(20deg, #5823f3 40%, #fa43bd 100%)',
        color: theme.colors.text,
        width: 'fit-content',
        position: 'relative',

        ['&:hover']: {
          color: theme.colors.text,
          backgroundImage: 'linear-gradient(20deg, #5823f3 40%, #5823f3 100%)'
        }
      }
    }
  };
}
